import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Stack, Typography } from '@mui/material';

export interface UploadErrorsProps {
  errors?: string[];
  onDiscard?: (index: number) => void;
}

export const UploadErrors = ({ errors = [], onDiscard }: UploadErrorsProps) => {
  const handleDiscard = (errorIndex: number) => () => {
    onDiscard?.(errorIndex);
  };
  return (
    <Stack
      direction="column"
      sx={{
        flex: 1,
      }}
    >
      {errors.map((error, index) => (
        <Stack
          key={index}
          direction="row"
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          <InfoOutlinedIcon fontSize="small" color="error" />
          <Typography
            color="error"
            sx={{
              fontSize: 'small',
            }}
          >
            {error}
          </Typography>
          <IconButton size="small" color="error" onClick={handleDiscard(index)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      ))}
    </Stack>
  );
};
